<template>
  <div class="experience-filter-container">
    <div class="c-block short no-top">

    <div class="row expanded small-collapse">
      <div class="columns large-12 large-centered">
        <div class="hide-for-small-only filter-bar--large alt">
          <div class="filter-bar--pane">
            <div class="row medium-collapse filter-bar--panerow">
              <div class="filter-bar--filters">
                <div class="columns medium-4">
                  <label for="subject">Category</label>
                  <p>
                    <select class="filter-bar--input" v-model="category">
                      <option value="all">All</option>
                      <option v-for="cat in categories" :value="cat.slug">
                        {{ cat.name }}
                      </option>
                    </select>
                  </p>
                </div>
                <div class="columns medium-4">
                  <label for="subject">Search</label>
                  <p>
                    <input @keyup="filterAll" v-model="keywords" class="filter-bar--input" type="text" value="" name="search" placeholder="Keyword">
                    <!-- <input v-model="keywords" class="filter-bar--input" type="text" value="" name="search" placeholder="Keyword"> -->
                  </p>
                </div>
                <div class="columns medium-4">
                  <label for="subject">Near</label>
                  <p>
                    <select class="filter-bar--input" v-model="location">
                      <option value="all">Location</option>
                      <option v-for="loc in locations" :value="loc.slug">
                        {{ loc.name }}
                      </option>
                    </select>
                  </p>
                </div>
              </div>
              <div class=" filter-bar--button-combo">
                <div class="o-listing-filter__filter-large o-listing-filter__filter-large-dropdown">
                  <select v-model="sortMethod" class="o-listing-filter__filter-large-select ">
                      <option value="none" disabled selected>Sort By</option>
                      <option v-for="method in sortMethods" :value="method.slug">
                        {{ method.name }}
                      </option>
                  </select>
                </div>

                <button @click="resetAllFilters" class="button" type="button">Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Mobile -->
    <div class="filter-bar--mobile-container show-for-small-only">
      <div class="o-listing-filter">
        <div class="o-listing-filter__mobile-container">
          <div class="row">
            <div class="columns small-10 small-centered">
              <ul data-accordion data-allow-all-closed="true" class="accordion filter-bar show-for-small-only" role="tablist">
                <li data-accordion-item="" >
                  <a href="#"  role="tab"  >
                    <div class="o-listing-filter__toggle-container">
                      <button type="button" class="o-listing-filter__toggle">
                        Filter by<i class="icon ion-android-arrow-dropdown"></i>
                      </button>
                    </div>
                  </a>
                  <div data-tab-content class="accordion-content o-listing-filter__pane" role="tabpanel"  >
                    <div class="o-listing-filter__filter-space"><label for="subject">Category</label>
                      <p><select class="filter-bar--input" v-model="category">
                          <option value="all">All</option>
                          <option v-for="cat in categories" :value="cat.slug">
                            {{ cat.name }}
                          </option>
                        </select>
                      </p>
                    </div>
                    <div class="o-listing-filter__filter-space"><label for="subject">Search</label>
                      <p><input @keyup="filterAll" v-model="keywords" class="filter-bar--input" type="text" value="" name="search" placeholder="Keyword"></p>
                    </div>
                    <div class="o-listing-filter__filter-space"><label for="subject">Near</label>
                      <p>
                        <select class="filter-bar--input" v-model="location">
                          <option value="all">All Locations</option>
                          <option v-for="loc in locations" :value="loc.slug">
                            {{ loc.name }}
                          </option>
                        </select>
                      </p>
                    </div>
                    <div class="o-listing-filter__filter-button small-12 u-center">
                      <button @click="resetAllFilters" class="button" type="button">Clear</button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
    <paginate
      :list="filteredList"
      :per="perPage"
      class="row expanded experience-card-divide trip-ideas"
      v-if="filteredList.length"
      name="experiences">
      <div class="columns small-12">
        <div class="row expanded small-up-2 medium-up-2 large-up-3 home-card-list">
          <div
            class="divide columns column-block"
            :key="index"
            v-for="(experience, index) in paginated('experiences')">
            <experience-card :content="experience" ></experience-card>
          </div>
        </div>
      </div>

    </paginate>
    <div v-else>
      <div class="columns small-12">
        <div class="row expanded small-up-2 medium-up-2 large-up-3 home-card-list">
          <div>No results. Try changing your search.</div>
        </div>
      </div>
    </div>

    <div class="o-pagination columns">
      <paginate-links
        class="o-pagination__pages margin-c c-block short"
        for="experiences"
        :show-step-links="true"
        :step-links="{
          next: '>',
          prev: '<'
        }"
        :async="true"
        @change="backToTop"
        :classes="{
        'li': 'o-pagination__page',
        }"
      ></paginate-links>
    </div>

  </div>
</template>


<script>

  import collect from 'collect.js';
  import ExperienceCard from './vue-partials/experience-card.vue';

  export default {

    name: 'ExperienceFilter',

    props: {
      experiences: {
        type: Array,
      }
    },

    data () {
      return {
        /**
        * How many to display per page
        * This can be changed and pagination updated on the fly
        * @type {Number}
        */
        perPage: 15,

        /**
        * What list do we paginate
        * @type {Array}
        */
        paginate: ['experiences'],

        /**
        * Bound to our search input
        * @type {String}
        */
        keywords: '',

        /**
        * Will be generated from the passed in Experiences
        * @type {Array}
        */
        locations: [],

        /**
        * The selected locoation - bound to the location select
        * @type {String}
        */
        location: '',

        /**
        * Will be generated from the passed in experiences
        * @type {Array}
        */
        categories: [],

        /**
        * The selected category - bound to the cateogory select
        * @type {String}
        */
        category: '',

        /**
        * The selected sort method - bound to the sort select
        * @type {String}
        */
        sortMethods: [
          {
            'name': 'A-Z',
            'slug': 'a-z',
            'desc': 'Sort alphabetically a-z ascending'
          },
          {
            'name': 'Z-A',
            'slug': 'z-a',
            'desc': 'Sort alphabetically z-a descending'
          },
          {
            'name': 'Newest',
            'slug': 'newest-first',
            'desc': 'Sort by date descending'
          },
          {
            'name': 'Oldest',
            'slug': 'oldest-first',
            'desc': 'Sort by date ascending'
          }
        ],

        /**
        * The selected sort method - bound to the sort select
        * @type {String}
        */
        sortMethod: '',

        /**
        * This will contain our filtered experiences
        * @type {Array}
        */
        filteredList: []
      };
    },

    computed:{
    },

    watch: {
      // we want to watch the category and keywords variables
      // and call `filterAll()` on either of them changing
      // this will ensure both filters are applied
      category () {
        this.filterAll();

        this.$nextTick(() => {
          this.callFoundation();
        });
      },

      location () {
        this.filterAll();

        this.$nextTick(() => {
          this.callFoundation();
        });
      },

      keywords () {
        this.filterAll();

        this.$nextTick(() => {
          this.callFoundation();
        });
      },

      sortMethod () {
        this.sortFilteredList();

        this.$nextTick(() => {
          this.callFoundation();
        });
      }
    },

    mounted () {

      this.categories = this.getCategoriesFromExperiences();
      this.locations = this.getLocationsFromExperiences();

      // Reset app on mounted
      this.resetAllFilters();
      this.callFoundation();
    },

    methods: {
      // Renit foundation components
      callFoundation () {
        this.$nextTick(() => {
          $(this.$el).foundation();
          Foundation.reInit($('[data-accordion]'));
        })
      },

      // Scroll to top on page change
      backToTop () {
        var target = $('.experience-filter-top');
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
        $('html,body').animate({
          // the 100 is a fixed header offset
            scrollTop: target.offset().top - 130
        }, 500);
          return false;
        }
      },

      /**
      * Filter everything
      * @return {void}
      */
      filterAll () {
        // reset the list to all experiences first
        this.filteredList = this.experiences;
        this.filterByCategory();
        this.filterByLocation();
        this.filterByKeywords();
      },

      /**
      * Reset the list back to it's initial state
      * This will trigger the filters and show everything
      * @return {void}
      */
      resetAllFilters () {
        this.callFoundation();

        this.filteredList = this.experiences;
        this.category = 'all'; // initial state is to show all categories
        this.location = 'all'; // initial state is to show all locations
        this.sortMethod = 'newest-first'; // initial state is newest first
      },

      /**
      * Go through all supplied experiences and get the categories
      * @return {array}
      */
      getCategoriesFromExperiences () {
        let categories = this.experiences.map(experience => {
          return experience.categories;
        });

        // horrible name, horrible, but we need to flatten those categories
        // Haha flat kitties, only kidding, we love cats here.
        let flatCats = [].concat.apply([], categories);

        // Generate unique objects
        flatCats = flatCats.filter((obj, pos, arr) => {
          return flatCats.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos;
        });

        return flatCats.sort(function( a, b ){
          return a.name > b.name ? 1 : -1;
        });
      },

      /**
      * Go through all supplied experiences and get the locations
      * @return {array}
      */
      getLocationsFromExperiences () {

        let locations = this.experiences.map(experience => {
          return experience.locations;
        });

        // horrible name, horrible, but we need to flatten those categories
        let flatCats = [].concat.apply([], locations);


        // Generate unique objects
        flatCats = flatCats.filter((obj, pos, arr) => {
          return flatCats.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos;
        });

        return flatCats.sort(function( a, b ){
          return a.name > b.name ? 1 : -1;
        });
      },


      /**
      * Filter the list from the free text search
      * Nothing too fancy, but it works
      * @return {void}
      */
      filterByKeywords () {
        if (!this.keywords) {
          return;
        }

        this.filteredList = this.filteredList.filter(experience => {
          // bringing everything to lowercase to make comparisons more reliable
          // i.e., "Search" !== "search"
          let experienceName = experience.title.toLowerCase();
          let searchQuery = this.keywords.toLowerCase();

          if (searchQuery !== '') {
            this.resetVisible = true;
          }

          return experienceName.indexOf(searchQuery) !== -1;
        });
      },

      /**
      * Filter the list by category
      * @return {void}
      */
      filterByCategory () {
        if (!this.category) {
          return;
        }

        if (this.category !== 'all') {
          this.filteredList = this.filteredList.filter(service => {
            this.resetVisible = true;

            let thisService = service;

            let targetCategory = this.category;

            // Create collection for the counties of this service
            let categoryCollection = collect(thisService.categories);

            // flatten collection, it doesn't matter that the names are mixed with slugs, only slugs will match
            // categoryCollection = categoryCollection.flatten();

            // thisService.categories = categoryCollection.all();

            // return thisService.categories.indexOf(targetCategory) !== -1;
            return thisService.categories.map(cat => cat.slug).indexOf(targetCategory) !== -1;
          });
        }
      },

      /**
      * Filter the list by location
      * @return {void}
      */
      filterByLocation () {
        if (!this.location) {
          return;
        }

        if (this.location !== 'all') {
          this.filteredList = this.filteredList.filter(experience => {
            this.resetVisible = true;

            let thisExperience = experience;

            let targetLocation = this.location;

            // Create collection for the locations of this experience
            let locationCollection = collect(thisExperience.locations);

            // flatten collection, it doesn't matter that the names are mixed with slugs, only slugs will match
            // locationCollection = locationCollection.flatten();

            // locationCollection = locationCollection.filter((value, key) => (key % 2) != 0);

            // thisExperience.locations = locationCollection.all();

            // return thisExperience.locations.slug.indexOf(targetLocation) !== -1;
            // return thisExperience.locations.findIndex(loc => loc.slug === targetLocation);
            return thisExperience.locations.map(loc => loc.slug).indexOf(targetLocation) !== -1;

          });
        }
      },

      sortFilteredList () {
        if (!this.sortMethod) {
          return;
        }

        if (this.sortMethod !== 'none') {

          switch ( this.sortMethod ) {
            case 'a-z':

              this.filteredList = this.filteredList.sort(function(a, b) {
                return a.title > b.title ? 1 : -1;
              });

              break;

            case 'z-a':

              this.filteredList = this.filteredList.sort(function(a, b) {
                return a.title < b.title ? -1 : 1;
              });

              break;

            case 'newest-first':

              this.filteredList = this.filteredList.sort(function(a, b) {
                var dateA = new Date(a.date).getTime();
                var dateB = new Date(b.date).getTime();
                return dateA > dateB ? 1 : -1;
              });

              break;

            case 'oldest-first':

              this.filteredList = this.filteredList.sort(function(a, b) {
                var dateA = new Date(a.date).getTime();
                var dateB = new Date(b.date).getTime();
                return dateA > dateB ? -1 : 1;
              });

              break;
          }

        }
      }

    }
  };
</script>



// WEBPACK FOOTER //
// src/js/vue/experience-filter.vue